<p-toolbar>
    <div class="p-toolbar-group-left flex gap-3">
    </div>

    <div class="p-toolbar-group-right flex gap-3">
        <button pButton
                type="button"
                label="New Home"
                class="p-button-success p-button-outlined mx-2"
                icon="pi pi-plus"
                (click)="addNew('new')">
        </button>
        <button pButton
                type="button"
                label="Reload Cache"
                class="p-button-outlined"
                icon="pi pi-refresh"
                (click)="reIndex()">
        </button>
    </div>
</p-toolbar>

<div *ngIf="models">
    <p-tabView>
        <p-tabPanel *ngFor="let cfg of models; let i= index;" [selected]="i === 0? true:false" header="{{cfg.header}}">
            <p-table [value]="cfg.data" [autoLayout]="true" [paginator]="true" [rows]="10" dataKey="id">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="text-align: center">Name</th>
                        <th style="text-align: center">Note</th>
                        <th style="text-align: center">Status</th>
                        <th style="text-align: center">Create</th>
                        <th style="text-align: center">Update</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-homeConfig>
                    <tr>
                        <td (click)="goToEditPage(homeConfig.id)" class="cursor-pointer">{{homeConfig.name}}</td>
                        <td (click)="goToEditPage(homeConfig.id)" class="cursor-pointer">{{homeConfig.note}}</td>
                        <td style="text-align: center">{{homeConfig.live ? 'LIVE' : ''}}</td>
                        <td style="text-align: center">{{homeConfig.created |date: 'dd/MM/yy'}}</td>
                        <td style="text-align: center">{{homeConfig.updated |date: 'dd/MM/yy'}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
    </p-tabView>
</div>

